export default function checkInternetConnection() {
	return window.navigator.onLine;
}
